import type { Definition } from '../../../../schema/frameworks/entry.js';
import { type SettingsKeys, type WagerSettings, wagerSettingsFormData } from '../../../../schema/sessionstore/entry.js';
import type { IUpdateWagerSettingsUseCase } from '../../../domain/entry.js';
import type { WagerSettingsDTO } from './types.js';

export type IUpdateWagerSettingsController = ReturnType<typeof updateWagerSettingsController>;

const createDTO = (settings: WagerSettings): WagerSettingsDTO => ({
  correction: settings.correction,
});

/**
 * Controller for updating user wager settings.
 *
 * @param updateWagerSettingsUseCase Use case for updating settings
 * @returns Controller executor function
 */
export function updateWagerSettingsController(updateWagerSettingsUseCase: IUpdateWagerSettingsUseCase) {
  /**
   * Updates wager settings in session storage.
   *
   * @param product Product from definition
   * @param input Form data payload
   * @param settingsKey Settings key, to update settings for my bets/results
   * @returns Persisted wager settings
   * @throws {Error} if persist were not permitted
   */
  return async function controller(
    product: Definition['moduleEngine'],
    input: FormData | WagerSettings,
    settingsKey: SettingsKeys
  ): Promise<WagerSettingsDTO> {
    const wagerSettings: WagerSettings = input instanceof FormData ? wagerSettingsFormData.parse(input) : input;
    const response = await updateWagerSettingsUseCase.execute({
      product,
      payload: {
        correction: wagerSettings.correction ?? [],
      },
      settingsKey,
    });

    return createDTO(response);
  };
}
